import moment from 'moment';
import _ from 'lodash';

import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { AdjustmentEnum } from 'Common/FieldEnum';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

import * as types from './types';

const INITIAL_STATE = {
  adjustmentListData: [],
  adjustmentListDataError: null,
  loading: false,
  printLoading: false,
  fetchingSites: false,
  selectedAdjustments: [],
  printLoadingError: null,
  fromDateMax: moment().add(1, 'month'),
  toDateMin: moment().subtract(1, 'month'),
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ADJUSTMENT_LIST_DATA: {
      return {
        ...state,
        adjustmentListData: action.payload.map(item => ({
          ...item,
          [AdjustmentEnum.TransactionDT]: [AdjustmentEnum.TransactionDT]
            ? moment(item[AdjustmentEnum.TransactionDT]).format(
                DATE_FORMAT_FOR_UI
              )
            : '',
        })),
      };
    }

    case types.ADJUSTMENT_LIST_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case types.ADJUSTMENT_CLEAR_GRID_DATA: {
      return {
        ...state,
        loading: false,
      };
    }

    case types.PRINT_PREVIEW_ERROR:
      if (_.has(action.payload, 'data.Data.Message')) {
        const printLoadingError = [
          {
            Title: TitleEnum.Error,
            Message: action.payload.data.Data.Message,
          },
        ];
        return {
          ...state,
          printLoadingError: printLoadingError,
        };
      }
      return {
        ...state,
        printLoadingError: action.payload,
      };

    case types.PRINT_PREVIEW_ADJUSTMENT_LOADING:
      return {
        ...state,
        printLoading: action.payload,
      };

    case types.CLEAR_ADJUSTMENT_LIST_ERROR:
      return {
        ...state,
        printLoadingError: null,
        adjustmentListDataError: null,
      };

    case types.SET_FROM_DATE_MAX:
      return {
        ...state,
        fromDateMax: action.payload,
      };

    case types.SET_TO_DATE_MIN:
      return {
        ...state,
        toDateMin: action.payload,
      };

    case types.ADJUSTMENT_LIST_ERROR:
      return {
        ...state,
        adjustmentListDataError: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/adjustment/state/adjustmentList/reducer.js